module.exports = __webpack_public_path__ + "c1a345ac3ea6563cbefafcfe0b095c75.png";